import {SelectTabData, SelectTabEvent, Tab, TabList, makeStyles} from "@fluentui/react-components";
import React from "react";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles({
  wrappingTabList: {
    flexWrap: 'wrap',
    rowGap: '8px',
    columnGap: '0px',
  },
  tabItem: {
    whiteSpace: 'nowrap',
  }
});

export interface TabNavigationProps {
  selectedValue: string;
  onTabSelect: (event: SelectTabEvent, data: SelectTabData) => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({ selectedValue, onTabSelect }) => {
  const styles = useStyles();
  const { t } = useTranslation();

  return (
    <TabList 
      selectedValue={selectedValue} 
      onTabSelect={onTabSelect}
      className={styles.wrappingTabList}
    >
      <Tab value="home" className={styles.tabItem}>{t("nav.home")}</Tab>
      <Tab value="groups" className={styles.tabItem}>{t("nav.audiences")}</Tab>
      <Tab value="messageSeries" className={styles.tabItem}>{t("nav.message_series")}</Tab>
      <Tab value="activeModules" className={styles.tabItem}>{t("nav.enrollments")}</Tab>
    </TabList>
  );
};
